import { SurveyBottomCompletionProps } from "./interfaces";

const SurveyBottomCompletion = ({ survey }: SurveyBottomCompletionProps) => {
    const length = survey.team.filter((t) => t.isSubmitted).length;
    return `${length}/${survey.team.length} members completed`;
};

export default SurveyBottomCompletion;
